<template>
<div class="box" v-if="pcHomeTopArr.length>0">
    <div class="adBox" :style="{backgroundImage: 'url(' + pcHomeTopArr[0].img + ')'}" @click="swiperClick(pcHomeTopArr[0])">
    </div>
</div>
</template>

<script>
import { isSafeRedirect } from '@/utils/index.js'
export default {
  name: 'ad',
  data () {
    return {
      pcHomeTopArr:[],
    }
  },
  mounted () {
	  this.gethomeTopBanner();
  },
  methods: {
    gethomeTopBanner(){
    	let data = {
    		codes: ["pc_home_top"]
    	};
    	let _this = this;
    	this.$api.getCarouselLists(data).then(res => {
    		if (res.status) {
    			if(res.data.list.pc_home_top){
    				_this.pcHomeTopArr = res.data.list.pc_home_top;
    			}
    		}
    	});
    },
    // /点击
    swiperClick(v) {
    	// type 1 url 直接跳转
    	// 2 商品
    	//  3 文章
    	// 4  文章分类
    	// 5 智能表单
    	this.$api.addRecord({
    		'type': '5',
    		'api_method': "advert.getcarousellists",
    		"platform": "1",
    		"code": v.code,
    		"rel_id": v.id
    	})
    	if (v.type == 1 && v.val!='#') {
    		if (isSafeRedirect(v.val)) {
    			window.open(v.val, '_blank')
    		}
    		return
    	}
    	
    	if (v.type == 2) {
    		this.$router.push({
    			path: `detail/${v.val}`,
    		})
    		return
    	}
    },
    
  }
}
</script>

<style scoped lang="scss">
.box {
  background: #fff;
}
.adBox{
    /* width: 1226px; */
	/* width:100%; */
    margin: auto;
    overflow: hidden;
	width: 100%;
	height: 80px;
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
}
</style>